@use "diy_base.module.scss";
@use "foundation/responsive";
@use "foundation/_colors.scss";

.service-connection {
  display: flex;
  flex-direction: column;
  align-items: center;

  max-width: diy_base.$box-width;
  color: colors.$primary-white;

  @include responsive.phone {
    max-width: diy_base.$box-width-phone;
  }

  .service-description {
    line-height: 1.388888889em;
    font-weight: 500;
    margin-bottom: diy_base.$diy-composer-margin;
    text-align: center;

    @include responsive.phone {
      margin-bottom: diy_base.$diy-composer-margin;
    }

    a {
      color: colors.$primary-white;
      text-decoration: underline;
    }
  }
}
